import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

const categoryImages = [
  'https://readdy.ai/api/search-image?query=Dark%20mysterious%20crime%20scene%20investigation%20with%20magnifying%20glass%20on%20vintage%20desk%2C%20warm%20amber%20lighting%2C%20film%20noir%20atmosphere%2C%20clean%20simple%20background%20with%20dark%20warm%20tones&width=600&height=400&seq=cat-suspense&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Romantic%20couple%20silhouette%20at%20sunset%20in%20modern%20city%20skyline%2C%20warm%20golden%20light%2C%20soft%20romantic%20atmosphere%2C%20cinematic%20film%20style%2C%20clean%20simple%20background%20with%20warm%20pink%20tones&width=600&height=400&seq=cat-romance&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20floating%20in%20magical%20clouds%20with%20golden%20glow%2C%20mystical%20fantasy%20atmosphere%2C%20traditional%20architecture%2C%20cinematic%20epic%20style%2C%20clean%20background%20with%20warm%20golden%20tones&width=600&height=400&seq=cat-fantasy&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Dynamic%20police%20action%20scene%20in%20urban%20city%20with%20dramatic%20lighting%2C%20fast%20motion%20feel%2C%20professional%20cinematography%2C%20warm%20amber%20and%20dark%20contrast%2C%20clean%20simple%20background&width=600&height=400&seq=cat-action&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Bright%20cheerful%20comedy%20film%20set%20with%20colorful%20props%20and%20warm%20lighting%2C%20joyful%20atmosphere%2C%20professional%20studio%20background%2C%20clean%20simple%20composition%20with%20warm%20yellow%20tones&width=600&height=400&seq=cat-comedy&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Professional%20documentary%20filming%20with%20camera%20lens%20and%20natural%20landscape%20background%2C%20warm%20earth%20tones%2C%20cinematic%20realistic%20style%2C%20clean%20simple%20composition&width=600&height=400&seq=cat-doc&orientation=landscape',
];

const imageMap: Record<string, string> = {
  suspense: categoryImages[0],
  romance: categoryImages[1],
  fantasy: categoryImages[2],
  action: categoryImages[3],
  comedy: categoryImages[4],
  documentary: categoryImages[5],
};

export default function CategoryShowcase() {
  const displayCategories = categories.filter((c) => c.id !== 'all');

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-medium text-accent-600 uppercase tracking-wider">内容分类</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">
            探索多元类型
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            六大类型覆盖，总有一款适合你的观影口味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {displayCategories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group relative rounded-lg overflow-hidden aspect-[3/4] cursor-pointer"
            >
              <img
                src={imageMap[cat.id]}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-600"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-black/10"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-end pb-5 px-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 backdrop-blur-sm mb-3 group-hover:bg-accent-500 transition-all duration-300">
                  <i className={`${cat.icon} text-lg text-white`}></i>
                </div>
                <span className="text-sm font-medium text-white whitespace-nowrap">{cat.name}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}